export const STORE = Object.freeze({
  AUTH: {
    TOKEN: "token",
    ID: "_id",
    PROFILE: "profile",
    ROLE: "role",
  },
  NOTIFICATION: {
    LIST: "notification-list",
  },
  RECOVERY: "recovery",
});
